"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applicationRouteConstants = void 0;
const applicationRouteConstants = exports.applicationRouteConstants = {
  MANAGEYOUR_TEAM: '/manageYourTeam',
  DEFAULT: '/identity',
  DEFAULTCDE: '/cde',
  CUSTOMER_STAGGING: 'https://customer.staging.weir',
  YOUR_WEIR: 'https://your.weir',
  MANAGEYOUR_TEAM_PAGE: '/manageYourTeam'
};